<app-page-heading [key]="'lite-login.title'"
                  [regions]="[]"
                  [carriers]="carriers"
                  [selectedCarrier]="carrier"
                  (selectedCarrierChange)="updateCarrier($event)"
                  [clearable]="false"
                  [helper]="true"
                  [helperContent]="helper">
</app-page-heading>

<section class="container-fluid summary-panel space-top-20">

    <div class="landing-page" *ngIf="!filters.carrierId && !canManageDrivers">
        <i class="fa fa-arrow-up"></i>
        <h1 [i18n]="'lite-login.prerequisite'"></h1>
    </div>

    <div class="main-content" *ngIf="filters.carrierId">
        <app-data-table [columns]="columns"
                        [noOverflow]="true"
                        [showColumnsSelection]="false"
                        [loadPage]="loadPage"
                        [(filters)]="filters"
                        [filtersComponent]="dataFilter"
                        [loadAtStartup]="true"
                        [sortColumn]="sortColumn"
                        [direction]="SortDirection.ASC"
                        (onReset)="resetFilters()">
            <app-data-filters #dataFilter
                              [opened]="true"
                              [titleKey]="'lite-login.filters.title'"
                              [showTitle]="true">
                <app-data-filter-group>
                    <app-data-filter-input [labelKey]="'lite-login.filters.labels.email'"
                                           [(model)]="filters.emailAddress">
                    </app-data-filter-input>
                    <app-data-filter-input [labelKey]="'lite-login.filters.labels.number'"
                                           [(model)]="filters.filterNumber">
                    </app-data-filter-input>
                    <app-data-filter-group [labelKey]="'lite-login.filters.labels.creation'" [spaceAuto]="true">
                        <app-data-filter-date [labelKey]="'lite-login.filters.labels.between'"
                                              [(model)]="filters.createdAtAfter">
                        </app-data-filter-date>
                        <app-data-filter-date [labelKey]="'lite-login.filters.labels.and'"
                                              [(model)]="filters.createdAtBefore">
                        </app-data-filter-date>
                    </app-data-filter-group>

                    <app-data-filter-select [labelKey]="'lite-login.filters.labels.status'"
                                            [options]="statusOptions"
                                            [(model)]="filters.status">
                    </app-data-filter-select>
                </app-data-filter-group>
            </app-data-filters>
            <app-data-buttons>
                <div class="text-right">
                    <button class="create-access btn btn-i btn-primary" (click)="goToCreateAccess()">
                        <i class="fa fa-plus"></i>
                        <span [i18n]="'lite-login.create-access'"></span>
                    </button>
                    <div class="alert alert-info space-top-10 text-left">
                        <i class="fa fa-info-circle"></i>
                        <span [i18n]="'lite-login.helpers.activation'"></span>
                    </div>
                </div>
            </app-data-buttons>
        </app-data-table>
    </div>

    <ng-template #userColumn let-emailAddress="emailAddress" let-source="source">
        <div class="email" *ngIf="source === LiteLoginAccessSource.CMAWEB">{{emailAddress}}</div>
        <div class="email" *ngIf="source === LiteLoginAccessSource.CICO_TABLET" [i18n]="'lite-login.cico-source'"></div>
    </ng-template>

    <ng-template #loadColumn let-tmsLoadsInfo="tmsLoadsInfo">
    <div class="load-info" *ngFor="let loadInfo of tmsLoadsInfo">
        <h3 class="load"><a class="cmaweb-link" [href]="link.goToLoadManagementForLoad(loadInfo.loadNumber)" target="_blank">{{loadInfo.loadNumber}}</a></h3>
        <div class="delivery"><a class="cmaweb-link" [href]="link.goToLoadManagementForDelivery(loadInfo.deliveryNumbers)" target="_blank">{{loadInfo.deliveryNumbers}}</a></div>
    </div>
    </ng-template>

    <ng-template #creationColumn let-createdAt="createdAt">
        <div class="creation-date">{{createdAt | fullDate}}</div>
    </ng-template>

    <ng-template #availabilityColumn let-activatedAt="activatedAt" let-expiresAt="expiresAt">
        <div class="availability">
            <div *ngIf="!activatedAt" [i18n]="'lite-login.not-activated'"></div>
            <div *ngIf="activatedAt">
                <div class="activation-date">{{activatedAt | fullDate}}</div>
                <div class="expiration-date">{{expiresAt | fullDate}}</div>
            </div>
        </div>
    </ng-template>

    <ng-template #useColumn let-firstUsedAt="firstUsedAt">
        <div class="availability">
            <div *ngIf="!firstUsedAt" [i18n]="'lite-login.not-used'"></div>
            <div *ngIf="firstUsedAt">
                <div class="activation-date">{{firstUsedAt | fullDate}}</div>
            </div>
        </div>
    </ng-template>

    <ng-template #statusColumn let-status="status" let-isExpired="isExpired">
        <div class="status _label" [ngClass]="isExpired ? 'EXPIRED' : status">
            <i class="status-icon fa" [ngClass]="isExpired ? 'EXPIRED' : status"></i>
            <span [i18n]="'lite-login.statuses.'+(isExpired ? 'EXPIRED' : status).toLowerCase()"></span>
        </div>
    </ng-template>

    <ng-template #actionsColumn
                 let-status="status"
                 let-isExpired=isExpired
                 let-id="id"
                 let-tmsLoadsInfo="tmsLoadsInfo"
                 let-emailAddress="emailAddress"
                 let-source="source">
        <dropdown-actions [labelKey]="'lite-login.columns.actions'">
            <div class="dropdown-item" *ngIf="status === LiteLoginAccessStatus.PENDING">
                <button class="btn btn-success btn-sm m-r-xs"
                        (click)="modify(id)"
                        [i18n]="[{target: 'attribute:title', key: 'lite-login.actions.activate'}]">
                    <i class="fa fa-check"></i>
                    <span [i18n]="[{target: 'innerHTML', key: 'lite-login.actions.activate'}]"></span>
                </button>
            </div>

            <div class="dropdown-item" *ngIf="status === LiteLoginAccessStatus.PENDING">
                <button class="btn btn-primary btn-sm m-r-xs"
                        (click)="modify(id)"
                        [i18n]="[{target: 'attribute:title', key: 'lite-login.actions.modify'}]">
                    <i class="fa fa-pen"></i>
                    <span [i18n]="[{target: 'innerHTML', key: 'lite-login.actions.modify'}]"></span>
                </button>
            </div>

            <div class="dropdown-item" *ngIf="status !== LiteLoginAccessStatus.PENDING && source === LiteLoginAccessSource.CMAWEB">
                <button class="btn btn-primary btn-sm m-r-xs"
                        (click)="see(id)"
                        [i18n]="[{target: 'attribute:title', key: 'lite-login.actions.see'}]">
                    <i class="fa fa-id-card"></i>
                    <span [i18n]="[{target: 'innerHTML', key: 'lite-login.actions.see'}]"></span>
                </button>
            </div>

            <div class="dropdown-item" *ngIf="status === LiteLoginAccessStatus.PENDING || isExpired">
                <button class="btn btn-danger btn-sm m-r-xs"
                        (click)="delete(id, emailAddress, tmsLoadsInfo)"
                        [i18n]="[{target: 'attribute:title', key: 'lite-login.actions.delete'}]">
                    <i class="fa fa-trash"></i>
                    <span [i18n]="[{target: 'innerHTML', key: 'lite-login.actions.delete'}]"></span>
                </button>
            </div>

            <div class="dropdown-item" *ngIf="(status === LiteLoginAccessStatus.ACTIVATED || status === LiteLoginAccessStatus.IN_USE) &&
                 !isExpired && source === LiteLoginAccessSource.CMAWEB">
                <button class="btn btn-primary btn-sm m-r-xs"
                        (click)="resendEmail(id, emailAddress)"
                        [i18n]="[{target: 'attribute:title', key: 'lite-login.actions.resend-mail'}]">
                    <i class="fa fa-envelope"></i>
                    <span [i18n]="[{target: 'innerHTML', key: 'lite-login.actions.resend-mail'}]"></span>
                </button>
            </div>

            <div class="dropdown-item" *ngIf="(status === LiteLoginAccessStatus.ACTIVATED || status === LiteLoginAccessStatus.IN_USE) && !isExpired">
                <button class="btn btn-primary btn-sm m-r-xs"
                        (click)="copyKey(id)"
                        [i18n]="[{target: 'attribute:title', key: 'lite-login.actions.copy-key'}]">
                    <i class="fa fa-copy"></i>
                    <span [i18n]="[{target: 'innerHTML', key: 'lite-login.actions.copy-key'}]"></span>
                </button>
            </div>

            <div class="dropdown-item" *ngIf="(status === LiteLoginAccessStatus.ACTIVATED || status === LiteLoginAccessStatus.IN_USE) && !isExpired">
                <button class="btn btn-primary btn-sm m-r-xs"
                        (click)="openQr(id)"
                        [i18n]="[{target: 'attribute:title', key: 'lite-login.actions.open-qr'}]">
                    <i class="fa fa-qrcode"></i>
                    <span [i18n]="[{target: 'innerHTML', key: 'lite-login.actions.open-qr'}]"></span>
                </button>
            </div>
        </dropdown-actions>
    </ng-template>
</section>

<ng-template #helper>
    <h3 class="text-primary text-left" [i18n]="'lite-login.helpers.section'"></h3>
    <spacer [size]="8"></spacer>
    <div class="stepContainer">
        <span class="step">1</span>
        <span class="stepContainer-label" [i18n]="'lite-login.helpers.step-1'"></span>
    </div>
    <div class="stepContainer">
        <span class="step">2</span>
        <span class="stepContainer-label" [i18n]="'lite-login.helpers.step-2'"></span>
    </div>
    <div class="stepContainer">
        <span class="step">3</span>
        <span class="stepContainer-label" [i18n]="'lite-login.helpers.step-3'"></span>
    </div>
</ng-template>

<ng-template #confirmPopup let-emailAddress="emailAddress" let-loadId="loadId">
    <div class="confirm-popup">
        <span><span [i18n]="'lite-login.confirm.delete.content'"></span>:</span>
        <spacer [size]="16"></spacer>
        <table>
            <th><span class="text-primary inline">{{emailAddress}}</span></th>
            <th><span class="text-primary inline">#{{loadId}}</span></th>
        </table>
    </div>
</ng-template>

<ng-template #confirmResendPopup let-emailAddress="emailAddress">
    <span [i18n]="'lite-login.confirm.resend-mail.content1'"></span>&nbsp;
    <h2 class="text-primary inline" style="margin-top: 8px;">{{emailAddress}}</h2>
    <div [i18n]="'lite-login.confirm.resend-mail.content2'"></div>
</ng-template>
